// extracted by mini-css-extract-plugin
export default {"crash-error-card":"CrashErrorLayout_crash-error-card__YZBrM"};